import { render } from "./WizardNameCorridoring.vue?vue&type=template&id=22c26bfa&scoped=true"
import script from "./WizardNameCorridoring.vue?vue&type=script&lang=js"
export * from "./WizardNameCorridoring.vue?vue&type=script&lang=js"

import "./WizardNameCorridoring.vue?vue&type=style&index=0&id=22c26bfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c26bfa"]])

export default __exports__